import classNames from 'classnames';
import { Link } from 'wouter';

import { useCategoryUrlGenerator } from '../../hooks/useUrlGenerator';

import CategoryTypography from '../typography/Category';

import styles from '../../styles/partials/category.module.css';

export interface CategoryProps {
    slug?: string | null;
    clickRef?: string | null;
    label?: string | null;
    placeholder?: boolean;
    withLink?: boolean;
    className?: string | null;
}

const Category = ({
    slug = null,
    clickRef = null,
    label = null,
    placeholder = false,
    withLink = false,
    className = null,
}: CategoryProps) => {
    const categoryUrl = useCategoryUrlGenerator();
    return (
        <CategoryTypography
            tag="div"
            placeholder={placeholder}
            className={classNames([styles.container, className])}
        >
            {withLink ? (
                <Link
                    href={
                        slug !== null
                            ? categoryUrl({
                                  slug,
                              })
                            : '#'
                    }
                    data-click-ref={clickRef}
                    className={styles.link}
                >
                    {label}
                </Link>
            ) : (
                label
            )}
        </CategoryTypography>
    );
};

export default Category;
